export enum ClientRequestStepTypes {
    FORM_UPLOAD = "formUpload",
    AUTH = "auth",
    EMAIL = "email",
}
